import {createFileRoute} from '@tanstack/react-router'
import ClashOfTeamsView from "../../../clash-of-teams/ClashOfTeamsView";

export const Route = createFileRoute('/_app/clash-of-teams/$uid/$page')({
    component: () => <ClashOfTeamsView />,
})
